/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { ActionType } from 'cio/models/action';
import STATE_INFO_MAP from 'cio/utils/state-label-map';
import Component from '@glimmer/component';

interface Args {
  deliveryState: string;
  actionType: ActionType;
  labelClassNames?: string;
}

export default class DeliveryStateTag extends Component<Args> {
  get isInAppUndeliverable() {
    return this.args.deliveryState === 'undeliverable' && this.args.actionType === 'in_app_action';
  }

  get content() {
    if (this.isInAppUndeliverable) {
      return 'This message was canceled. Expand the delivery to see why it was canceled.';
    }

    if (typeof this.stateInfo?.description === 'string') {
      return this.stateInfo.description;
    }

    return this.stateInfo?.description[this.args.actionType] ?? this.stateInfo?.description?.email_action ?? '';
  }

  get stateInfo() {
    return STATE_INFO_MAP.find(({ state }) => state === this.args.deliveryState);
  }
}
